document.querySelectorAll('[data-manufacturer-catalog]').forEach(catalog => {
  const search = catalog.querySelector('[data-catalog-search]');
  const group = catalog.querySelector('[data-catalog-group]');
  const cards = [...catalog.querySelectorAll('[data-catalog-card]')];
  const update = () => {
    const query = search.value.trim().toLowerCase();
    let count = 0;
    cards.forEach(card => {
      const visible = (!query || card.dataset.search.includes(query)) && (!group.value || card.dataset.group === group.value);
      card.hidden = !visible;
      if (visible) count += 1;
    });
    catalog.querySelector('[data-catalog-count]').textContent = String(count);
    catalog.querySelector('[data-catalog-empty]').hidden = count !== 0;
  };
  search.addEventListener('input', update);
  group.addEventListener('change', update);
  catalog.addEventListener('click', event => {
    const button = event.target.closest('[data-catalog-quote]');
    if (!button) return;
    const page = catalog.closest('.sp-detail');
    const field = page.querySelector('[data-requested-product]');
    const form = page.querySelector('#category-quote');
    if (!field || !form) return;
    field.value = button.dataset.catalogQuote;
    form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    page.querySelector('#CatApplication')?.focus({ preventScroll: true });
  });
});
